<template>
    <!-- TODO: @Roza (error display - some border?) -->
    <div class="text-center" :class="{ 'is-error': hasError }">
        <c-video-maker @loadVideo="handleUploadVideo($event)" :previewMode="preview" />
        <p v-if="editMode" class="text-gray-500 py-4">{{ $t("r_shared.or") }}</p>
        <FormFiles
            v-model="videoFiles"
            accept="video/*"
            :maxSize="10485760"
            @fileSelected="handleUploadVideo"
            @fileRemoved="handleRemoveVideo"
            singleFile
            :labels="{
                clickToUpload: $t('shared.uploader.click_to_upload'),
                dragAndDrop: $t('shared.uploader.drag_and_drop'),
                fileInfo: $t('shared.uploader.video_file_details'),
            }"
        />
        <FormNotification error> {{ error }} </FormNotification>
    </div>
</template>

<script>
import { mapState } from "vuex";
import cVideoMaker from "./cVideoMaker.vue";
import { FormFiles, FormNotification } from "@easy/ui/forms";

export default {
    name: "cVideo",
    props: {
        video: String,
        editMode: Boolean,
        withBorder: Boolean,
        borderColor: String,
        backgroundColor: String,
        acceptTypes: {
            type: String,
            default: "video/*",
        },
        error: {
            type: String,
            default: "",
        },
    },
    emits: ["uploadVideo", "removeVideo"],
    components: {
        cVideoMaker,
        FormFiles,
        FormNotification,
    },
    data() {
        return {
            dragged: false,
            videoFiles: [],
        };
    },
    computed: {
        ...mapState("shared/view", ["preview"]),
        hasError() {
            return Boolean(this.error);
        },
    },
    methods: {
        handleUploadVideo(video) {
            this.$emit("uploadVideo", video);
        },
        handleRemoveVideo() {
            this.$emit("removeVideo");
        },
    },
};
</script>
